import { EventEmitter, Injectable, Output } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';

import { deComponentMessages, deCustomMessages } from '../messages/de-DE';
import { elComponentMessages, elCustomMessages } from '../messages/el-GR';
import { enComponentMessages, enCustomMessages } from '../messages/en-US';
import { frComponentMessages, frCustomMessages } from '../messages/fr-FR';
import { ruComponentMessages, ruCustomMessages } from '../messages/ru-RU';

const componentMsgs: any = {
    ['de-DE']: deComponentMessages,
    ['el-GR']: elComponentMessages,
    ['en-US']: enComponentMessages,
    ['fr-FR']: frComponentMessages,
    ['ru-RU']: ruComponentMessages
};

const customMsgs: any = {
    ['de-DE']: deCustomMessages,
    ['el-GR']: elCustomMessages,
    ['en-US']: enCustomMessages,
    ['fr-FR']: frCustomMessages,
    ['ru-RU']: ruCustomMessages
};

@Injectable()
export class CustomMessagesService extends MessageService {
    @Output() public localeChange = new EventEmitter();
    private localeId: string = 'en-US';

    public set language(value: string) {
        const locale = componentMsgs[value];
        if (locale) {
            this.localeId = value;
            this.localeChange.emit();
            this.notify();
        }
    }

    public get language(): string {
        return this.localeId;
    }

    private get messages(): any {
        const messages = componentMsgs[this.localeId];
        if (messages) {
            return messages;
        }
    }

    public override get(key: string): string {
        return this.messages[key];
    }

    //public override get(key: string): string {
    //    const messages = this.messages[key];
    //    return key.split('.').reduce((acc, part) => acc?.[part], messages) || key;
    //}

    // Translate custom messages
    public _translate(word: string): string {
        const messages = customMsgs[this.localeId];
        return messages[word];
    }

    public translate(key: string): string {
        const messages = customMsgs[this.localeId];
        return key.split('.').reduce((acc, part) => acc?.[part], messages) || key;
    }
}
